import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosPrivate from "../../services/axios/axiosPrivate";
import api from "../../services/api";

// KPI Chart
export const fetchKPI = createAsyncThunk(
  "dashboard/fetchKPI",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosPrivate.get(api.dashboardChartKpi);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch KPI"
      );
    }
  }
);

// Employee Chart
export const fetchEmployee = createAsyncThunk(
  "dashboard/fetchEmployee",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosPrivate.get(
        `${api.dashboardChartKpi.replace("/kpi", "/employee")}`
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch Employee Data"
      );
    }
  }
);

// Candidate Chart
export const fetchCandidate = createAsyncThunk(
  "dashboard/fetchCandidate",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosPrivate.get(
        `${api.dashboardChartKpi.replace("/kpi", "/candidate")}`
      );
      return res.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch Candidate Data"
      );
    }
  }
);

const dashboardChartSlice = createSlice({
  name: "dashboard",
  initialState: {
    kpi: null,
    employee: null,
    candidate: null,

    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchKPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKPI.fulfilled, (state, action) => {
        state.loading = false;
        state.kpi = action.payload;
      })
      .addCase(fetchKPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchEmployee.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployee.fulfilled, (state, action) => {
        state.loading = false;
        state.employee = action.payload;
      })
      .addCase(fetchEmployee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchCandidate.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCandidate.fulfilled, (state, action) => {
        state.loading = false;
        state.candidate = action.payload;
      })
      .addCase(fetchCandidate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardChartSlice.reducer;